import { render, staticRenderFns } from "./PlaceMediaCard.vue?vue&type=template&id=74dd1a43&"
import script from "./PlaceMediaCard.vue?vue&type=script&lang=js&"
export * from "./PlaceMediaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports